import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import VideocamIcon from "@mui/icons-material/Videocam";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PersonIcon from "@mui/icons-material/Person";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

/**
 * Students panel navigation.
 *
 * Route list only - see the admin equivalent for why there are no colors here.
 * جزوه (/dashboard/books) was commented out in the previous markup and is left
 * out rather than carried over as dead code; re-add the entry to restore it.
 */
export const STUDENT_NAV = [
  {
    to: "/dashboard/home",
    label: "داشبورد کاربر",
    icon: AccountBalanceWalletIcon,
  },
  { to: "/dashboard/classes", label: "جلسات", icon: VideocamIcon },
  { to: "/dashboard/exams", label: "امتحانات", icon: TextSnippetIcon },
  {
    to: "/dashboard/homework",
    label: "تکالیف",
    icon: DriveFileRenameOutlineIcon,
  },
  { to: "/dashboard/books", label: "جزوات", icon: LibraryBooksIcon },
];

export const studentFooterNav = (onLogout) => [
  { to: "/dashboard/profile", label: "پروفایل", icon: PersonIcon },
  { to: "/dashboard/rules", label: "قوانین", icon: VerifiedUserIcon },
  {
    label: "خروج",
    icon: LogoutRoundedIcon,
    onClick: onLogout,
    tone: "danger",
  },
];
